<template>

<otif-modal ref="add-ecm-repository" v-bind:title="ecmResourceStrings.ttlCreateRepository" :value="value" @input="$emit('input', $event)" @shown="onShown">
<b-form>
    <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
    <otif-textInput
        v-model="$v.repositoryId.$model"
        v-bind:label="ecmResourceStrings.lblRepositoryID"
        :required="true"
        :validation="$v.repositoryId"
        v-bind:invalidMessage="ecmResourceStrings.msgRepositoryIDrequired"
        :description="ecmResourceStrings.tipRepositoryID"
        ref="first_input" />
    <ecmrepotype-select
        v-model="$v.repository_type.$model"
        v-bind:label="ecmResourceStrings.lblRepositoryType"
        :required="true"
        ref="ecmrepositorytype_selector"
        :validation="$v.repository_type"
        :description="ecmResourceStrings.tipRepositoryType"
        v-bind:invalidMessage="ecmResourceStrings.msgRepositoryTyperequired"
        v-bind:flag="flag"
    />
    <otif-textarea
        v-model="repository_description"
        v-bind:label="ecmResourceStrings.lblDescription"
        :description="ecmResourceStrings.tipRepositoryDescription" />
        <template  v-if="flag != 'RDBMS'">
            <otif-select
                v-bind:label="ecmResourceStrings.lblItemProcessingMode"
                v-model="$v.processing_mode.$model"
                :required="true"
                :validation="$v.processing_mode"
                :values="processing_modes"
                @input.native='onchange'
                :description="ecmResourceStrings.tipProcessMode"
                />
        </template>
</b-form>
<template slot="footer">
    <b-button @click="createEcmRepository" :disabled="$v.$invalid" variant=" OTPrimary">{{ecmResourceStrings.lblSave}}</b-button>
    <b-button @click="cancel" variant="  OTSecondary">{{ecmResourceStrings.lblCancel}}</b-button>
</template>
</otif-modal>

</template>

<script>

import EcmRepositoryTypeSelect from '../../../ecm/components/widgets/ECMRepositoryTypeSelector.vue';
import axios from 'axios';
import EcmRepositoryModel from '../../../ecm/models/ecmrepository.js';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import ecmRepositories from '@/ecm/collections/ecmrepositories.js'; 
import { showMessage} from '../../utils/commonECM.js';
import ECMErrorDialog from '../modals/ECMCrawlerMessageDlg.vue';
import { numericval } from '../../utils/validatorECM.js';

export default {
    components: {
        'ecmrepotype-select': EcmRepositoryTypeSelect,
        ECMErrorDialog,
    },
    props: ['value', 'flag'],
    mixins: [
        validationMixin
    ],
    data() {
        return {
            ecmResourceStrings: require('../../utils/resourceECM.js'),
            ecmRepositories: new ecmRepositories({paginated: false }),  
            listOfExistingRepositories:[],
            messageDlg: false,
            processing_modes :
            [
                'Full crawl',
                'Fast crawl'
            ],
            processing_mode: 'Full crawl',
            repository_type: '',
            repositoryId: '',
            repository_description: ''
        }
    },

    validations: {
        repository_type: {
            required
        },
        repositoryId: {
            required, numericval
        },
        processing_mode: {
            required
        }
    },

    methods: {
        onShown() {
            var that = this;
            this.processing_mode = 'Full crawl';
            this.repository_type = '';
            if(this.flag == 'RDBMS')
            {
                this.repository_type ='dbms_generic_v1';
            }
            this.repositoryId = '';
            this.repository_description = '';
            if (this.$route.params['repository_type']) {
                this.repository_type = this.$route.params['repository_type'];
            }
            this.$refs.first_input.focus();
            this.$refs.ecmrepositorytype_selector.refresh();
            this.ecmRepositories.fetch({"Content-Type": "application/json; charset=UTF-8"})
            .then(() => {
                this.listOfExistingRepositories =  this.ecmRepositories.resources; 
                if(this.listOfExistingRepositories.length > 0)
                {
                    var i = 0;
                    for(i=1001;i<10000;i++)
                    {
                        var result = that.listOfExistingRepositories.find(e => (e.id == i));
                        if (result == undefined)
                        {
                            this.repositoryId = i;
                               
                            return;
                        }
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
        },

        cancel() {
            this.$emit('input', false);
        },

        createBodyPostString()
        {
            var procMode = 0;
            if(this.processing_mode != 'Full crawl')
            {
                procMode = 1;
            }
            const   configstring = '{"name": "itemProcessingMode", "value": "' + procMode +'", "type": "int", "description": ""}';
            var configdescr='';
            if(this.repository_description.length > 0)
            {
                //configdescr = escape(this.repository_description); 
                configdescr = JSON.stringify(this.repository_description); 
                //configdescr = configdescr.replace(/"/g, ""); 
                configdescr = configdescr.replace(/"/ , ""); 
                configdescr = configdescr.replace(/"$/,"");
            }                   
            const connString = '{"repositoryId": "' + this.repositoryId + '", "repositoryName": "", "repositoryType": "' + this.repository_type + '", "description": "' + configdescr + '", "configData":[' + configstring + ']}';
            return connString;
        },

        createEcmRepository() {
            for (var cnt=0;  cnt< this.listOfExistingRepositories.length; cnt++)
            {
                if(Number(this.listOfExistingRepositories[cnt].id) === Number(this.repositoryId))
                {
                    this.$snotify.clear();
                    this.$snotify.error('Repository with this ID already exists', this.ecmResourceStrings.txtError);
                    return;
                }
            }
            this.$snotify.async('Saving Repository', {timeout: 0});
            const data = this.createBodyPostString();
             axios.post('/mtm-gateway-api/v1/services/ecm/ECMRepositories', data,  {headers: {"Content-Type": "application/json; charset=UTF-8"}})
             .then(() => {
                this.$snotify.clear();
                if(this.flag != 'RDBMS')
                {
                    this.$snotify.success('ECM Repository Created');
                    this.$router.push('/settings/ecmrepositories/' + encodeURIComponent(this.repositoryId) + '/ecm-repo-general');
                }
                else
                {
                    this.$snotify.success('RDBMS Repository Created');
                    this.$router.push('/settings/rdbmsrepositories/' + encodeURIComponent(this.repositoryId) + '/rdbms-repo-general');
                }
                this.$emit('input', false);
            })
            .catch((err) => {
                this.$snotify.clear();
                if(err.response)
                {
                    if(err.response.data)
                    {
                        this.$snotify.error('Error saving Repository.', err.response.statusText, {
                            buttons: [
                                {text: this.ecmResourceStrings.txtViewDetails, action:()=>this.$eventBus.$emit('show-error-ecm', 'Error saving Repository.', err.response.statusText, err.response.data), bold: true },
                            ]
                        });
                    }
                    else if(err.response.statusText)
                    {
                        this.$snotify.error('Error saving Repository.', err.response.statusText, {
                            buttons: [
                                {text: this.ecmResourceStrings.txtViewDetails, action:()=>this.$eventBus.$emit('show-error-ecm', 'Error saving Repository.', err.response.statusText, err.response.data), bold: true },
                            ]
                        });
                    }
                    else
                    {
                        this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
                    }
                }
                else  if(err.message)
                {
                    this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
                }
                else{
                    this.$snotify.error('Error saving Repository.');
                }
            });
        }
    },
}

</script>
